import React from "react";
import { Form, Row, Col, Card } from "react-bootstrap";
import moment from "moment";
import { Icon } from "@cdk-uip/react-icon";
import useValidation from "../../util/useValidation";
import {
  alphaNumericWithSpecialCharacterPattern,
  embeddedSpacesPattern
} from "../../constants/constants";

export const OrganizationDetailsForm = ({
  organizationDetails,
  index,
  updateCandidateOrganizationDetails,
  deleteCandidateOrganizationDetails
}) => {
  const { handleOnBlurValidation, errors } = useValidation();
  const handOnBlurInput = e => {
    handleOnBlurValidation(e);
  };
  const handleOnChangeOrganizationDetails = ({
    target: { name, value, type, checked }
  }) => {
    if (embeddedSpacesPattern.test(value)) {
      const updatedValue = getUpdatedValue(type, value, checked);
      updateCandidateOrganizationDetails(
        organizationDetails.id,
        name,
        updatedValue
      );
    }
  };
  const getUpdatedValue = (type, value, checked) => {
    if (type === "checkbox") return Number(checked);
    else if (type === "date") {
      const isValidDate = moment(value).isValid();
      return isValidDate ? moment(value).format("YYYY-MM-DD") : null;
    } else return value.trimStart();
  };

  return (
    <Card {...(index !== 0 && { className: "mt-2" })}>
      <Card.Header className="accordian-header">
        <Row>
          <Col sm={11}>Organization Details</Col>
          {index !== 0 && (
            <Col sm={1} className="text-right">
              <Icon
                onClick={() =>
                  deleteCandidateOrganizationDetails(organizationDetails.id)
                }
              >
                delete
              </Icon>
            </Col>
          )}
        </Row>
      </Card.Header>
      <Card.Body>
        <Form.Group as={Row} controlId="name">
          <Form.Label column sm={2} className="text-right">
            Name*
          </Form.Label>
          <Col sm={10}>
            <Form.Control
              size="sm"
              required
              placeholder="Name"
              type="text"
              name="organizationName"
              value={organizationDetails.organizationName}
              onChange={handleOnChangeOrganizationDetails}
              onBlur={handOnBlurInput}
              isInvalid={errors.organizationName}
              pattern={alphaNumericWithSpecialCharacterPattern}
            />
            {errors.organizationName && (
              <Form.Control.Feedback type="invalid">
                {errors.organizationName.type === "required" &&
                  "Name is required"}
                {errors.organizationName.type === "pattern" &&
                  "Invalid characters entered for Name"}
              </Form.Control.Feedback>
            )}
          </Col>
        </Form.Group>
        <Form.Group as={Row} controlId="jobTitleLocation">
          <Form.Label column sm={2} className="text-right">
            Job Title*
          </Form.Label>
          <Col sm={4}>
            <Form.Control
              size="sm"
              required
              placeholder="Job Title"
              type="text"
              name="jobTitle"
              value={organizationDetails.jobTitle}
              onChange={handleOnChangeOrganizationDetails}
              onBlur={handOnBlurInput}
              isInvalid={errors.jobTitle}
              pattern={alphaNumericWithSpecialCharacterPattern}
            />
            {errors.jobTitle && (
              <Form.Control.Feedback type="invalid">
                {errors.jobTitle.type === "required" && "Job Title is required"}
                {errors.jobTitle.type === "pattern" &&
                  "Invalid characters entered for Job Title"}
              </Form.Control.Feedback>
            )}
          </Col>
          <Form.Label column sm={2} className="text-right">
            Location*
          </Form.Label>
          <Col sm={4}>
            <Form.Control
              size="sm"
              required
              placeholder="Location"
              type="text"
              name="location"
              value={organizationDetails.location}
              onChange={handleOnChangeOrganizationDetails}
              onBlur={handOnBlurInput}
              isInvalid={errors.location}
              pattern={alphaNumericWithSpecialCharacterPattern}
            />
            {errors.location && (
              <Form.Control.Feedback type="invalid">
                {errors.location.type === "required" && "Location is required"}
                {errors.location.type === "pattern" &&
                  "Invalid characters entered for Location"}
              </Form.Control.Feedback>
            )}
          </Col>
        </Form.Group>

        <Form.Group as={Row} controlId="orgDates">
          <Form.Label column sm={2} className="text-right">
            Date Of Joining*
          </Form.Label>
          <Col sm={4}>
            <Form.Control
              size="sm"
              required
              type="date"
              placeholder="Date Of Joining"
              name="joiningDate"
              value={moment(organizationDetails.joiningDate).format(
                "YYYY-MM-DD"
              )}
              onChange={handleOnChangeOrganizationDetails}
              onBlur={handOnBlurInput}
              isInvalid={errors.joiningDate}
            />
            {errors.joiningDate && (
              <Form.Control.Feedback type="invalid">
                {errors.joiningDate.type === "required" &&
                  "Joining Date is required"}
              </Form.Control.Feedback>
            )}
          </Col>

          <Form.Label column sm={2} className="text-right">
            Last Working Day
          </Form.Label>
          <Col sm={4}>
            <Form.Control
              size="sm"
              type="date"
              placeholder="Last Working Day"
              name="lastWorkingDate"
              value={moment(organizationDetails.lastWorkingDate).format(
                "YYYY-MM-DD"
              )}
              onChange={handleOnChangeOrganizationDetails}
            />
          </Col>
        </Form.Group>
        <Form.Group as={Row} controlId="employeeDepartment">
          <Form.Label column sm={2} className="text-right">
            Department
          </Form.Label>
          <Col sm={4}>
            <Form.Control
              size="sm"
              placeholder="Department"
              type="text"
              name="departmentName"
              value={organizationDetails.departmentName}
              onChange={handleOnChangeOrganizationDetails}
              pattern={alphaNumericWithSpecialCharacterPattern}
              onBlur={handOnBlurInput}
              isInvalid={errors.departmentName}
            />
            {errors.departmentName && (
              <Form.Control.Feedback type="invalid">
                {errors.departmentName.type === "pattern" &&
                  "Invalid characters entered for Department"}
              </Form.Control.Feedback>
            )}
          </Col>
          <Form.Label column sm={2} className="text-right">
            Employee Code
          </Form.Label>
          <Col sm={4}>
            <Form.Control
              size="sm"
              placeholder="Employee Code"
              type="text"
              name="employeeCode"
              value={organizationDetails.employeeCode}
              onChange={handleOnChangeOrganizationDetails}
              onBlur={handOnBlurInput}
              isInvalid={errors.employeeCode}
              pattern={alphaNumericWithSpecialCharacterPattern}
            />
            {errors.employeeCode && (
              <Form.Control.Feedback type="invalid">
                {errors.employeeCode.type === "pattern" &&
                  "Invalid characters entered for Employee Code"}
              </Form.Control.Feedback>
            )}
          </Col>
        </Form.Group>
        <Form.Group as={Row} controlId="employeeDepartment">
          <Col sm={12} className="text-right">
            <Form.Check
              type="checkbox"
              label="Current Organization"
              name="lastOrganization"
              checked={organizationDetails.lastOrganization}
              onChange={handleOnChangeOrganizationDetails}
            />
          </Col>
        </Form.Group>
      </Card.Body>
    </Card>
  );
};
export default OrganizationDetailsForm;
